import React from 'react';
import { Accordion, Button, Card, Col, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';

import { TrunkAddressesForm } from '@components/Capacity/Trunks/TrunkAddressesForm';
import { TrunkDetailsForm } from '@components/Capacity/Trunks/TrunkDetailsForm';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page500 } from '@containers/ErrorPages';
import { capacityApi } from '@reducers/capacity/capacity';

export const TrunkDetails = () => {
  const { trunkID } = useParams();
  const details = capacityApi.useGetUserTrunkDetailsQuery({ trunkID });
  const addresses = capacityApi.useGetUserTrunkAddressesQuery({ trunkID });
  const isLoading =
    details.isLoading ||
    details.isFetching ||
    addresses.isLoading ||
    addresses.isFetching;
  const isError = details.isError || addresses.isError;
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }

  return (
    <Row>
      <Col md={12}>
        <Card>
          <Card.Header className="bg-didxl text-white">
            Customer Trunk
          </Card.Header>
          <Card.Body>
            <Accordion
              defaultActiveKey={['details']}
              className="mb-4"
              alwaysOpen
            >
              <Accordion.Item eventKey="details">
                <Accordion.Header>Trunk details</Accordion.Header>
                <Accordion.Body>
                  <TrunkDetailsForm data={details.data} />
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="addresses">
                <Accordion.Header>Trunk addresses</Accordion.Header>
                <Accordion.Body>
                  <TrunkAddressesForm data={addresses.data} />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Button as={Link} variant="didxl" size="sm" to="/capacity/trunks">
              Exit
            </Button>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
